<template>
  <div>
    <div class="date-container">
      <div class="date-section" v-for="item in copy.dates">
        <h2>{{ item.date }}</h2>
        <p>{{ item.deadline }}</p>
      </div>
    </div>
    <div class="group-container">
      <div class="group-section" v-for="item in copy.groups">
        <h2>{{ item.date }}</h2>
        <p>{{ item.deadline }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  var md = require("markdown-it")();
  module.exports =  {
    name: 'dates',
    props:['copy'],
    methods: {
      md: function(input) {
        return md.render(input);
      },
      mdInline: function(input) {
        return md.renderInline(input);
      }
    },
  }
</script>

<style scoped></style>
